
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"64","height":"64","viewBox":"0 0 64 64","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"32","cy":"32","r":"32","fill":"#7B2CBF"}}),_c('path',{attrs:{"d":"M32.2388 21.3386C29.0156 21.2211 26.2984 23.5991 26.0082 26.7779C25.9225 27.7152 26.6154 28.5437 27.5552 28.6291C28.4795 28.7023 29.3248 28.0246 29.4115 27.0863C29.5361 25.7176 30.7039 24.6705 32.0998 24.7437C33.4244 24.797 34.5611 25.9594 34.5822 27.2815C34.5978 28.2076 34.134 29.0484 33.341 29.5331C31.4269 30.6999 30.2835 32.1465 30.2835 34.296C30.2835 35.2365 31.0487 35.9996 31.9919 35.9996C32.935 35.9996 33.7002 35.2365 33.7002 34.296C33.7002 33.3432 34.2319 32.9825 35.1239 32.439C36.9323 31.3354 38.0345 29.3367 37.9989 27.2249C37.9478 24.106 35.3641 21.4662 32.2388 21.3386Z","fill":"white"}}),_c('path',{attrs:{"d":"M31.9998 42.6656C33.1043 42.6656 33.9996 41.7703 33.9996 40.6658C33.9996 39.5614 33.1043 38.666 31.9998 38.666C30.8953 38.666 30 39.5614 30 40.6658C30 41.7703 30.8953 42.6656 31.9998 42.6656Z","fill":"white"}})])
          )
        }
      }
    